<template>
    <div class="modal fade" tabindex="-1" ref="modal">
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('taskDetail.sims.zonesTitle', { code }) }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" :aria-label="$t('common.cancel')"></button>
                </div>
                <div class="modal-body">
                    <div class="table-responsive">
                        <table class="table small mb-0">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">{{ $t('taskDetail.sims.zoneCode') }}</th>
                                    <th scope="col">{{ $t('taskDetail.sims.zoneName') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="loading">
                                    <td colspan="3" class="text-center">
                                        <span class="spinner-border spinner-border-sm" role="status"></span>
                                    </td>
                                </tr>
                                <tr v-else-if="error">
                                    <td colspan="3" class="text-center">{{ $t('taskDetail.noConnection') }}</td>
                                </tr>
                                <tr v-else-if="zones.length === 0">
                                    <td colspan="3" class="text-center">{{ $t('taskDetail.sims.noZones') }}</td>
                                </tr>
                                <tr v-else v-for="zone in zones" :key="zone.row_number">
                                    <td>{{ zone.row_number }}</td>
                                    <td>{{ zone.zone_code }}</td>
                                    <td>{{ zone.zone_name }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import axios from '@/services/axios';
import { Modal } from 'bootstrap';

export default {
    props: {
        taskId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            code: '',
            zones: [],
            loading: false,
            error: false,
        };
    },
    beforeUnmount() {
        // Leaving the task with the modal open must not leave its backdrop behind.
        Modal.getInstance(this.$refs.modal)?.dispose();
        document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
        document.body.classList.remove('modal-open');
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('padding-right');
    },
    methods: {
        // Takes a row of the sims-accounts list. Stored accounts carry their zones
        // in it ([] = really none); null (child accounts, or USS didn't answer for
        // the list) is fetched on open and not cached.
        async open(account) {
            const code = account.sims_account;
            this.code = code;
            this.error = false;
            Modal.getOrCreateInstance(this.$refs.modal).show();

            if (Array.isArray(account.zones)) {
                this.zones = account.zones;
                this.loading = false;
                return;
            }

            this.zones = [];
            this.loading = true;
            try {
                const response = await axios.get(`tasks/${this.taskId}/sims-accounts/${encodeURIComponent(code)}/zones`);
                // Another account was opened while this one was loading.
                if (this.code !== code) return;
                this.zones = Array.isArray(response.data?.data) ? response.data.data : [];
            } catch (error) {
                if (this.code !== code) return;
                // 404 is the API's "no zones" answer, not a broken connection.
                if (error?.response?.status !== 404) {
                    console.error('Error fetching SIMS zones:', error);
                    this.error = true;
                }
            } finally {
                if (this.code === code) this.loading = false;
            }
        },
    }
};
</script>
